import theme from "../../styles/theme";
import {css} from "emotion";
import React from "react";

export const Logo = (props) => {
    var logo;
    try{
         logo = require('../../assets/logo_' + props.shortName.toString().toLowerCase() + '.png');
    } catch (err){
        console.warn("missing logo for " + props.shortName.toString().toLowerCase());
        logo = require('../../assets/empty.png');
    }
    return (
        <div style={{display: "block", width: props.width, height: props.height, marginLeft: props.marginLeft}}>
            <img src={logo} alt={"logo " + props.shortName}
                 style={{maxWidth: props.width, maxHeight: props.height, width: "auto", height: "auto"}}/>
        </div>
    )
};
export const ModelLabel = (props) => {
    const modelName = props.modelName.split(" ").slice(-1).pop();
    let backgroundColor = theme.colors.lightGray;
    let color = theme.colors.secondaryColor;
    switch (modelName.toUpperCase()) {
        // created from https://colourco.de/
        // BLUEISH: (ECMWF)
        // #3E6DAD -> HRES
        // #5887C5 -> EFI-SOT
        // #7DA2D3 -> WAM
        // #A3BDE1 -> TCP
        // #C9D9EE -> ENS
        // #8DA2D8 -> ENSEXT
        // #377D98 -> SEAS
        //
        // GREENISH: (UKMO)
        // #396725 -> UKV
        // #4D8E31 -> UKVX
        // #61B53D -> WAFS
        // #7DC95C -> GLOBAL
        // #9BD781
        //
        // REDDISH: (NCEP)
        // #6D2927 -> GFS
        // #943633 -> HRRR
        // #BB423F -> RAP
        // #CB6462 -> NAM
        // #D98988 -> WW3
        // #E09F9E -> GEFS
        //
        // YELLOWISH: (CMC)
        // #BCA943 -> GDPS
        // #CABB68 -> GEPS
        // #D8CC8D -> RDPS
        // #E6DDB2
        // #F3EED8
        //
        // PURPLISH: (MERCATOR)
        // #9D3859 -> BIO
        // #C04870 -> PHY
        // #CE6D8D
        // #DB93AB
        // #E8B9C8
        //
        // ORANGISH: (DWD)
        // #FF8C1A -> COSMO-D2
        // #FFA64D -> ICON
        // #FFBF80 -> ICONEU
        // #FFD9B3
        // #FFF2E6
        //
        // BROWNISH: (NCEP/NWS/MDL)
        // #5D3D21 -> GLMP
        // #84562E -> NBM
        // #AB6F3A
        // #C68851
        // #D3A277
        //
        // GRAYISH: (DTN)
        // #000000 -> METSAT
        // #414141 -> SCADO
        // #8B8B8B -> MANTA
        // #999999 -> EMPOWER
        // #708090 -> MDSS
        // #556370 -> 1QPE
        // #36454F -> 1Fx
        //
        case 'UKV':
            backgroundColor = "#396725";
            color = theme.colors.lightGray;
            break;
        case 'UKVX':
            backgroundColor = "#4D8E31";
            color = theme.colors.lightGray;
            break;
        case 'WAFS':
            backgroundColor = "#61B53D";
            color = theme.colors.lightGray;
            break;
        case 'GLOBAL':
            backgroundColor = "#7DC95C";
            color = theme.colors.lightGray;
            break;
        case 'HRES':
            backgroundColor = "#3E6DAD";
            color = theme.colors.lightGray;
            break;
        case 'EFI-SOT':
            backgroundColor = "#5887C5";
            color = theme.colors.lightGray;
            break;
        case 'WAM':
            backgroundColor = "#7DA2D3";
            color = theme.colors.lightGray;
            break;
        case 'TCP':
            backgroundColor = "#A3BDE1";
            color = theme.colors.lightGray;
            break;
        case 'ENS':
            backgroundColor = "#C9D9EE";
            color = theme.colors.lightGray;
            break;
        case 'ENSEXT':
            backgroundColor = "#8DA2D8";
            color = theme.colors.lightGray;
            break;
        case 'SEAS':
            backgroundColor = "#377D98";
            color = theme.colors.lightGray;
            break;
        case 'GFS':
            backgroundColor = "#6D2927";
            color = theme.colors.lightGray;
            break;
        case 'HRRR':
            backgroundColor = "#943633";
            color = theme.colors.lightGray;
            break;
        case 'RAP':
            backgroundColor = "#BB423F";
            color = theme.colors.lightGray;
            break;
        case 'NAM':
            backgroundColor = "#CB6462";
            color = theme.colors.lightGray;
            break;
        case 'WW3':
            backgroundColor = "#D98988";
            color = theme.colors.lightGray;
            break;
        case 'GEFS':
            backgroundColor = "#E09F9E";
            color = theme.colors.lightGray;
            break;
        case 'COSMO-D2':
            backgroundColor = "#FF8C1A";
            color = theme.colors.lightGray;
            break;
        case 'ICON':
            backgroundColor = "#FFA64D";
            color = theme.colors.lightGray;
            break;
        case 'ICON-EU':
            backgroundColor = "#FFBF80";
            color = theme.colors.lightGray;
            break;
        case 'GDPS':
            backgroundColor = "#BCA943";
            color = theme.colors.lightGray;
            break;
        case 'GEPS':
            backgroundColor = "#CABB68";
            color = theme.colors.lightGray;
            break;
        case 'RDPS':
            backgroundColor = " #D8CC8D";
            color = theme.colors.lightGray;
            break;
        case 'BIO':
            backgroundColor = "#9D3859";
            color = theme.colors.lightGray;
            break;
        case 'PHY':
            backgroundColor = "#C04870";
            color = theme.colors.lightGray;
            break;
        case 'GLMP':
            backgroundColor = "#5D3D21";
            color = theme.colors.lightGray;
            break;
        case 'NBM':
            backgroundColor = "#84562E";
            color = theme.colors.lightGray;
            break;
        case 'METSAT':
            backgroundColor = "#00000E";
            color = theme.colors.lightGray;
            break;
        case 'SCADO':
            backgroundColor = "#414141";
            color = theme.colors.lightGray;
            break;
        case 'MANTA':
            backgroundColor = "#8B8B8B";
            color = theme.colors.lightGray;
            break;
        case 'EMPOWER':
            backgroundColor = "#999999";
            color = theme.colors.lightGray;
            break;
        case 'MDSS':
            backgroundColor = "#708090";
            color = theme.colors.lightGray;
            break;
        case '1QPE':
            backgroundColor = "#556370";
            color = theme.colors.lightGray;
            break;
        case '1FX':
            backgroundColor = "#36454F";
            color = theme.colors.lightGray;
            break;
        default:
            backgroundColor = theme.colors.lightGray;
            color = "black";
    }
    const modelLabel = css`
        text-align: center;
        border-radius: 4px;
        background-color: ${backgroundColor};
        color: ${color};
        padding: 5px;
        max-width: auto;
        width: auto;
        font-size: 12px;
    `;
    let style = [];
    style['backgroundColor'] = "red";
    return <b>
        <div className={modelLabel}>{modelName}</div>
    </b>;
    // import { Textfit } from 'react-textfit';
    //return <b><div className={modelLabel}><Textfit mode={"single"} forceSingleModeWidth={true} throttle={0}>{modelName}</Textfit></div></b>;

};



// WEBPACK FOOTER //
// ./src/components/results/headerItems.js